<template>
    <div class="block block-rounded">
        <div class="block-content block-content-full">
            <template v-if="wizardStep == 1">
                <div class="row row-deck row-cols-lg-4 row-cols-sm-4 row-cols-2 max-height-lg" :class="{'flex-lg-column': Object.keys(vehicleTypes).length >= 8}">
                    <template v-for="(vehicleType, index) in vehicleTypes">
                        <div v-if="vehicleType.showInWizard">
                            <a class="mb-4 rounded d-block" href="#" v-on:click.prevent="selectedType = index;advance()" :class="index === selectedType ? 'bg-success-light' : 'bg-body-dark'">
                                <img class="img-fluid" :src="`/images/portal/${vehicleType.name}.png`">
                                <h4 class="my-1 my-md-4 text-center">
                                    {{ vehicleType.name }}
                                </h4>
                            </a>
                        </div>
                    </template>
                </div>
                <a href="#" v-on:click.prevent="selectedType = 'other';advance()">
                    Vehicle type not listed? Click here
                </a>
            </template>
            <template v-else>
                <h3>Your Vehicle</h3>
                <div class="d-flex align-items-center mb-4 bg-body-dark rounded p-2 col-lg-3">
                    <div class="item item-rounded-lg bg-body-light mv-2 rounded">
                        <img v-if="selectedType != 'other'" class="img-fluid" :src="`/images/portal/${selectedVehicleType.name}.png`">
                        <i v-else class="fa fa-question"></i>
                    </div>
                    <span class="m-3">{{ selectedVehicleType.name }}</span>
                </div>
            </template>

            <div v-show="wizardStep == 2" class="row">
                <h3>Collecting From</h3>
                <div class="col-sm-6 d-none d-lg-block mb-4">
                    <div style="height:500px;width:100%" ref="collectionMap"></div>
                </div>
                <div class="col-sm-6 mt-md-0">
                    <div class="mb-4">
                        <label class="form-label">Company Name</label>
                        <input type="text" class="form-control" ref="collectionCompanyName" v-model="collectionCompanyName" />
                    </div>
                    <div class="mb-4">
                        <label class="form-label">Address Lookup</label>
                        <input class="form-control" ref="collectionLookupAddress" type="text" placeholder="Type address here" v-model="selectedCollectionAddress" />
                        <input type="hidden" ref="collectionLocaleInput" />
                        <input type="hidden" ref="collectionLatitudeInput" />
                        <input type="hidden" ref="collectionLongitudeInput" />
                    </div>
                    <div class="mb-4">
                        <label class="form-label">Collection Date</label>
                        <input type="text" class="form-control js-flatpickers" ref="collectionDatePicker" v-model="collectionDate"
                               placeholder="dd/mm/yyyy" data-date-format="d/m/Y" required />
                    </div>
                    <div class="mb-4">
                        <label class="form-label">Collection Time</label>
                        <div class="space-x-2">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="Any" v-model="collectionTime">
                                <label class="form-check-label">Any Time</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="AM" v-model="collectionTime">
                                <label class="form-check-label">AM</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="PM" v-model="collectionTime">
                                <label class="form-check-label">PM</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="wizardStep == 3">
                <h3>Collecting From</h3>
                <div class="d-flex align-items-center mb-4 bg-body-dark rounded p-2 col-md-6">
                    <img class="d-none d-lg-block" :src="collectionMapUrl">
                    <div class="px-2">
                        <div>
                            <strong class="mr-1">Company Name:</strong>
                            <span>{{ this.collectionCompanyName }}</span>
                        </div>
                        <div class="mt-3">
                            <strong>Address:</strong>
                            <div v-for="addressLine in selectedCollectionAddress.split(',')">{{addressLine}}</div>
                        </div>
                        <div class="mt-3">
                            <strong class="mr-1">Date:</strong>
                            <span>{{ this.collectionDate }}</span>
                        </div>
                        <div>
                            <strong class="mr-1">Time:</strong>
                            <span>{{ this.collectionTime }}</span>
                        </div>
                    </div>
                </div>
                <h3>Delivering To</h3>
                <div class="row">
                    <div class="col-sm-6 d-none d-lg-block mb-4">
                        <div style="height:500px;width:100%" ref="deliveryMap"></div>
                    </div>
                    <div class="col-sm-6 mt-md-0">
                        <div class="mb-4">
                            <label class="form-label">Company Name</label>
                            <input type="text" class="form-control" ref="deliveryCompanyName" v-model="deliveryCompanyName" />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">Address Lookup</label>
                            <input class="form-control" ref="deliveryLookupAddress" type="text" placeholder="Type address here" v-model="selectedDeliveryAddress"/>
                            <input type="hidden" ref="deliveryLocaleInput" />
                            <input type="hidden" ref="deliveryLatitudeInput" />
                            <input type="hidden" ref="deliveryLongitudeInput" />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">Delivery Date</label>
                            <input type="text" class="form-control js-flatpickers" ref="deliveryDatePicker" v-model="deliveryDate"
                                placeholder="dd/mm/yyyy" data-date-format="d/m/Y" required />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">Delivery Time</label>
                            <div class="space-x-2">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" value="Any" v-model="deliveryTime">
                                    <label class="form-check-label">Any Time</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" value="AM" v-model="deliveryTime">
                                    <label class="form-check-label">AM</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" value="PM" v-model="deliveryTime">
                                    <label class="form-check-label">PM</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="wizardStep == 4">
                <div class="row">
                    <div class="col-md-7 mb-4 d-lg-block d-none">
                        <h3>Overview</h3>
                        <img class="img-fluid" :src="deliveryMapUrl">
                    </div>
                    <div class="col-lg-5">
                        <div class="row">
                            <div class="col-lg-12 col-auto flex-grow-1">
                                <h3>Collecting From</h3>

                                <div class="mb-4 bg-body-dark rounded p-3 py-2">
                                    <div>
                                        <strong class="mr-1">Company Name:</strong>
                                        <span>{{ this.collectionCompanyName }}</span>
                                    </div>
                                    <div class="mt-3">
                                        <strong>Address:</strong>
                                        <div>{{ this.selectedCollectionAddress }}</div>
                                    </div>
                                    <div class="mt-3">
                                        <strong class="mr-1">Date:</strong>
                                        <span>{{ this.collectionDate }}</span>
                                    </div>
                                    <div>
                                        <strong class="mr-1">Time:</strong>
                                        <span>{{ this.collectionTime }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-auto flex-grow-1">
                                <h3>Delivering To</h3>

                                <div class="mb-4 bg-body-dark rounded p-3 py-2">
                                    <div>
                                        <strong class="mr-1">Company Name:</strong>
                                        <span>{{ this.deliveryCompanyName }}</span>
                                    </div>
                                    <div class="mt-3">
                                        <strong>Address:</strong>
                                        <div>{{ this.selectedDeliveryAddress }}</div>
                                    </div>
                                    <div class="mt-3">
                                        <strong class="mr-1">Date:</strong>
                                        <span>{{ this.deliveryDate }}</span>
                                    </div>
                                    <div class="d-inline">
                                        <strong class="mr-1">Time:</strong>
                                        <span>{{ this.collectionTime }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h3>Transportation Options</h3>

                <div class="row row-deck row-cols-lg-5 row-cols-md-3 row-cols-2">
                    <div v-for="(transportType, index) in transportTypes">
                        <a class="mb-4 rounded w-100 text-center d-block" href="#" v-on:click.prevent="selectedTransportType = transportType" :class="transportType === selectedTransportType ? 'bg-success-light' : 'bg-body-dark'">
                            <i
                                class="fas fs-3 mt-4"
                                :class="{
                                    'fa-car': transportType == 'Driven',
                                    'fa-truck-moving': transportType == 'Transported',
                                }"
                            ></i>
                            <h4 class="my-4">
                                {{transportType}}
                            </h4>
                        </a>
                    </div>
                </div>

                <h3 class="mt-0 mt-md-4">Vehicle Count</h3>
                <div class="form-group">
                    <input class="form-control" placeholder="How many vehicles are being moved?" v-model="vehicleCount">
                </div>

                <h3 class="mt-0 mt-md-4">Your Name</h3>
                <div class="form-group">
                    <input class="form-control" placeholder="Your Name" v-model="customerContactName">
                </div>

                <h3 class="mt-0 mt-md-4">Job Notes</h3>
                <div class="form-group">
                    <textarea class="form-control" placeholder="Add any relevant information or queries." rows="3" v-model="jobNotes"></textarea>
                </div>
            </template>
            <div class="d-flex justify-content-between mt-4">
                <button class="btn btn-primary" v-on:click="this.previous" :disabled="wizardStep == 1">
                    Go back
                </button>
                <button class="btn btn-primary" v-on:click="this.advance" :href="'#section' + this.wizardStep">
                    {{this.wizardStep != '4' ? 'Continue' : 'Request Quote'}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Eventbus } from '@/components/eventbus';

const maps = [],
    collectionmarkers = [],
    delivermarkers = [],
    lats = [],
    lngs = [];

var initialise = function(map, input, localeinput, latitude, longitude, maptype) {
    map = new google.maps.Map(map, {
        center: {
            lat: 55.1198611,
            lng: -4.2826482
        },
        zoom: 5,
        fullscreenControl: false,
        scrollwheel: false
    });
    maps.push(map);

    lats.push(latitude);
    lngs.push(longitude);

    var autocomplete = new google.maps.places.Autocomplete(input, {
        fields: [
            'address_component',
            'formatted_address',
            'geometry'
        ]
    });
    autocomplete.bindTo('bounds', map);

    var collectionmarker = new google.maps.Marker({
        map: map,
        icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
    });
    collectionmarkers.push(collectionmarker);
    var delivermarker = new google.maps.Marker({
        map: map,
        icon: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
    });
    delivermarkers.push(delivermarker);

    var marker;
    if (maps.length === 1) {
        marker = collectionmarker;
    } else {
        marker = delivermarker;
    }
    //marker.setDraggable(true);

    if (latitude.value.length && longitude.value.length) {
        let position = new google.maps.LatLng(latitude.value, longitude.value);
        map.setCenter(position);
        map.setZoom(17);
        marker.setPosition(position);
        marker.setVisible(true);
    }

    var timer = null;
    marker.addListener('position_changed', function() {
        clearTimeout(timer);
        timer = setTimeout(function() {
            latitude.value = marker.getPosition().lat();
            longitude.value = marker.getPosition().lng();

            map.setCenter(marker.getPosition());
            if (map.getZoom() == 5) {
                map.setZoom(17);
            }

            estimateMileage(true);
        }, 500);
    });

    //marker.addListener('dragend', function(event) {
    //    geocode(event.latLng);
    //});

    autocomplete.addListener('place_changed', function() {
        marker.setVisible(false);
        var place = autocomplete.getPlace();
        if (place === undefined) {
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        marker.setPosition(place.geometry.location);
        marker.setVisible(true);

        var locale = [];
        place.address_components.forEach(function(component) {
            switch (component.types[0]) {
                case 'locality':
                case 'postal_town':
                case 'administrative_area_level_2':
                    // sometimes locality and postal_town are the same value so try not to make duplicates
                    if (locale.indexOf(component.long_name) < 0) {
                        locale.push(component.long_name);
                    }
                    break;
            }
        });
        var localeString = locale.join(', ');
        localeinput.value = localeString;
        input.value = place.formatted_address;
        Eventbus.emit('sendFormattedAddress', [place.formatted_address, localeString]); // need to get and set which type of address to set

        // geocode(place.geometry.location);
    });

    // geocode the location on the map to provide a complete address to the input
    var geocoder = new google.maps.Geocoder;
    function geocode(latLng) {
        geocoder.geocode({'location': latLng}, function(results, status) {
            if(status === 'OK') {
                if(results[0]) {
                    var locale = [];
                    results[0].address_components.forEach(function(component) {
                        switch (component.types[0]) {
                            case 'locality':
                            case 'postal_town':
                            case 'administrative_area_level_2':
                                // sometimes locality and postal_town are the same value so try not to make duplicates
                                if (locale.indexOf(component.long_name) < 0) {
                                    locale.push(component.long_name);
                                }
                                break;
                        }
                    });
                    var localeString = locale.join(', ');
                    localeinput.value = localeString;
                    input.value = results[0].formatted_address;
                    Eventbus.emit('sendFormattedAddress', [results[0].formatted_address, localeString]); // need to get and set which type of address to set
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }
        });
    }

    // very easy to hit enter when searching for a location which would submit the entire form
    google.maps.event.addDomListener(input, 'keydown', function(e) {
        if (e.keyCode == 13) {
            e.preventDefault();
        }
    });
};

var directionsdisplay = [];
var estimateMileage = function(automatic) {
    var directionsservice = new google.maps.DirectionsService(),
        points = [],
        okay = true;

    if (typeof automatic === "undefined") {
        automatic = false;
    }

    for (let key in lats) {
        if (okay) {
            let lat = lats[key].value,
                lng = lngs[key].value;

            if (lat.length < 1 || lng.length < 1) {
                okay = false;
                if (automatic === false) {
                    alert('Please complete the collection and delivery sections first.');
                }
            }
            else {
                points.push(new google.maps.LatLng(lat, lng));
            }
        }
    }

    if (okay) {
        // if the markers don't have a position or the position is incorrect, update it
        // - if you don't do this check there shall be infinite recursion
        collectionmarkers.forEach(function(marker) {
            if ( (!marker.getPosition()) || (marker.getPosition().lat() != points[0].lat() && marker.getPosition().lng() != points[0].lng()) ) {
                marker.setPosition(points[0]);
            }
        });

        delivermarkers.forEach(function(marker) {
            if ( (!marker.getPosition()) || (marker.getPosition().lat() != points[1].lat() && marker.getPosition().lng() != points[1].lng()) ) {
                marker.setPosition(points[1]);
            }
        });

        if (directionsdisplay.length > 0) {
            directionsdisplay.forEach(function(dd) {
                dd.setMap(null);
            });
            directionsdisplay = [];
        }

        maps.forEach(function(map) {
            directionsdisplay.push(new google.maps.DirectionsRenderer({
                map: map,
                polylineOptions: {
                    strokeColor: '#1ab394'
                },
                preserveViewport: true,
                suppressMarkers: true,
            }));
        });

        directionsservice.route({
            origin: points[0],
            destination: points[1],
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.IMPERIAL
        }, function(result, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                directionsdisplay.forEach(function(dd) {
                    dd.setDirections(result);
                });

                var travelled = 0;
                result.routes[0].legs[0].steps.forEach(function(step) {
                    var wut = step.distance.text.split(" ");
                    if (wut[1] == "ft") {
                        travelled += parseFloat(wut[0]) / 5280;
                    } else if (wut[1] == "mi") {
                        travelled += parseFloat(wut[0]);
                    } else {
                        alert("Unhandled: ".wut[1]);
                    }
                });

                Eventbus.emit('estimatedMileage', Math.ceil(travelled));
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Route error',
                    text: "Unable to find a route between the collection and delivery addresses.",
                });
            }
        });
    }
};

export default {
    props: {
        vehicleTypes: {
            type: Object
        },
        staticMapUrl: {
            type: String
        },
        saveQuoteRoute: {
            type: String
        },
        transportTypes: {
            type: Array,
        },
        today: String,
        quoteId: {
            type: Number,
            default: null,
        },
        existingSelectedCollectionAddress: {
            type: String,
            default: '',
        },
        existingSelectedCollectionLocale: {
            type: String,
            default: '',
        },
        existingSelectedCollectionLat: {
            type: String,
            default: '',
        },
        existingSelectedCollectionLng: {
            type: String,
            default: '',
        },
        existingSelectedDeliveryLocale: {
            type: String,
            default: '',
        },
        existingSelectedDeliveryLat: {
            type: String,
            default: '',
        },
        existingSelectedDeliveryLng: {
            type: String,
            default: '',
        },
        existingSelectedDeliveryAddress: {
            type: String,
            default: '',
        },
        existingCollectionDate: {
            type: String,
            default: '',
        },
        existingCollectionTime: {
            type: String,
            default: 'Any',
        },
        existingDeliveryDate: {
            type: String,
            default: '',
        },
        existingDeliveryTime: {
            type: String,
            default: 'Any',
        },
        existingCollectionMapUrl: {
            type: String,
            default: '',
        },
        existingDeliveryMapUrl: {
            type: String,
            default: '',
        },
        existingSelectedTransportType: {
            type: String,
            default: '',
        },
        existingEstimatedMileage: {
            type: Number,
            default: null,
        },
        existingCustomerContactName: {
            type: String,
            default: '',
        },
        existingJobNotes: {
            type: String,
            default: '',
        },
        existingVehicleCount: {
            type: Number,
            default: 1,
        },
        existingSelectedType: {
            type: String,
            default: null,
        },
        existingCollectionCompanyName: {
            type: String,
            default: '',
        },
        existingDeliveryCompanyName: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            wizardStep: 1,
            selectedCollectionAddress: this.existingSelectedCollectionAddress,
            selectedCollectionLocale: this.existingSelectedCollectionLocale,
            selectedCollectionLat: this.existingSelectedCollectionLat,
            selectedCollectionLng: this.existingSelectedCollectionLng,
            selectedDeliveryAddress: this.existingSelectedDeliveryAddress,
            selectedDeliveryLocale: this.existingSelectedDeliveryLocale,
            selectedDeliveryLat: this.existingSelectedDeliveryLat,
            selectedDeliveryLng: this.existingSelectedDeliveryLng,
            collectionDate: this.existingCollectionDate,
            collectionTime: this.existingCollectionTime,
            collectionCompanyName: this.existingCollectionCompanyName,
            deliveryDate: this.existingDeliveryDate,
            deliveryTime: this.existingDeliveryTime,
            deliveryCompanyName: this.existingDeliveryCompanyName,
            collectionMapUrl: this.existingCollectionMapUrl,
            deliveryMapUrl: this.existingDeliveryMapUrl,
            selectedTransportType: this.existingSelectedTransportType,
            estimatedMileage: this.existingEstimatedMileage,
            customerContactName: this.existingCustomerContactName,
            jobNotes: this.existingJobNotes,
            vehicleCount: this.existingVehicleCount,
            selectedType: this.existingSelectedType,
        }
    },
    mounted () {
        this.todayDate = Date.parse(new Date(this.today).toDateString());
        Eventbus.on('sendFormattedAddress', (payload) => {
            if (this.wizardStep == 2) {
                this.selectedCollectionAddress = payload[0];
                this.selectedCollectionLocale = payload[1];
                this.selectedCollectionLat = this.$refs.collectionLatitudeInput.value;
                this.selectedCollectionLng = this.$refs.collectionLongitudeInput.value;
            } else if (this.wizardStep == 3) {
                this.selectedDeliveryAddress = payload[0];
                this.selectedDeliveryLocale = payload[1];
                this.selectedDeliveryLat = this.$refs.deliveryLatitudeInput.value;
                this.selectedDeliveryLng = this.$refs.deliveryLongitudeInput.value;
            }
        });

        Eventbus.on('estimatedMileage', (mileage) => {
            if (typeof mileage === 'number') {
                this.estimatedMileage = mileage;
            } else {
                this.estimatedMileage = null;
            }
        });
    },
    watch: {
        collectionDate (newValue) {
            this.deliveryDate = newValue;
        },
    },
    computed: {
        selectedVehicleType () {
            return this.vehicleTypes[this.selectedType] || null;
        },
    },
    methods: {
        advance() {
            let validated = this.validate();
            if (validated) {
                if (this.wizardStep == 1) {
                    this.wizardStep++;
                    window.onbeforeunload = function() {
                        return "Changes that you made may not be saved."; // message doesn't matter: https://chromestatus.com/feature/5349061406228480
                    };
                    if (this.$refs.collectionMap.childNodes.length == 0) {
                        if (this.quoteId !== null) {
                            this.$refs.collectionLongitudeInput.value = this.selectedCollectionLng;
                            this.$refs.collectionLatitudeInput.value = this.selectedCollectionLat;
                        }
                        setTimeout(() => {
                            initialise(
                                this.$refs.collectionMap,
                                this.$refs.collectionLookupAddress,
                                this.$refs.collectionLocaleInput,
                                this.$refs.collectionLatitudeInput,
                                this.$refs.collectionLongitudeInput
                            );
                        }, 500);
                    }
                } else if (this.wizardStep == 2) {
                    this.wizardStep++;
                    if (this.$refs.deliveryMap.childNodes.length == 0) {
                        if (this.quoteId !== null) {
                            this.$refs.deliveryLongitudeInput.value = this.selectedDeliveryLng;
                            this.$refs.deliveryLatitudeInput.value = this.selectedDeliveryLat;
                        }
                        setTimeout(() => {
                            initialise(
                                this.$refs.deliveryMap,
                                this.$refs.deliveryLookupAddress,
                                this.$refs.deliveryLocaleInput,
                                this.$refs.deliveryLatitudeInput,
                                this.$refs.deliveryLongitudeInput
                            );
                        }, 500);
                    }
                    if (this.deliveryDate == '') {
                        this.deliveryDate = this.collectionDate;
                    }
                    axios.post(this.staticMapUrl, {
                        coords: JSON.stringify([
                            {lat: this.$refs.collectionLatitudeInput.value, lng: this.$refs.collectionLongitudeInput.value},
                        ]),
                    }).then((response) => {
                        this.collectionMapUrl = response.data;
                    });
                } else if (this.wizardStep == 3) {
                    this.wizardStep++;
                    axios.post(this.staticMapUrl, {
                        coords: JSON.stringify([
                            {lat: this.$refs.collectionLatitudeInput.value, lng: this.$refs.collectionLongitudeInput.value},
                            {lat: this.$refs.deliveryLatitudeInput.value, lng: this.$refs.deliveryLongitudeInput.value},
                        ]),
                        height: 400,
                        width: 640, // max size
                    }).then((response) => {
                        this.deliveryMapUrl = response.data;
                    });

                } else if (this.wizardStep == 4) {
                    this.submit();
                }
            }
        },
        previous() {
            if (this.wizardStep > 1) {
                this.wizardStep--;
            }
        },
        validate() {
            switch (this.wizardStep) {
                case 1:
                    if (this.selectedVehicleType === null) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Please ensure you have selected a vehicle type',
                        });
                        return false;
                    }
                    return true;
                case 2:
                    if (this.selectedCollectionAddress == '' || this.collectionDate == '') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Please ensure you have added a collection address and collection date',
                        });
                        return false;
                    }
                    var niceCollectionDate = this.fixDate(this.collectionDate);

                    if (niceCollectionDate == this.todayDate) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Collection date is today',
                            text: 'If you wish to arrage a collection for today, contact JK directly to discuss options',
                        });
                        return false;
                    } else if (niceCollectionDate <= this.todayDate) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Collection date cannot be before today',
                        });
                        return false;
                    }
                    return true;
                case 3:
                    var niceCollectionDate = this.fixDate(this.collectionDate);
                    var niceDeliveryDate = this.fixDate(this.deliveryDate);
                    if (this.selectedDeliveryAddress == '' || this.deliveryDate == '') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Please ensure you have added a delivery address and delivery date',
                        });
                        return false;
                    }
                    if (niceDeliveryDate < niceCollectionDate) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Delivery date cannot be before the collection date',
                        });
                        return false;
                    } else if (niceDeliveryDate == niceCollectionDate && this.collectionTime == 'PM' && this.deliveryTime == 'AM') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Delivery time cannot be before the collection time',
                        });
                        return false;
                    }
                    return true;
                case 4:
                    if (this.selectedTransportType == '') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Please ensure you have selected how your vehicle needs to be transported',
                        });
                        return false;
                    } else if (this.customerContactName == '') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Please ensure you have entered your name',
                        });
                        return false;
                    }
                    if (parseInt(this.vehicleCount) < 1) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Error',
                            text: 'Please ensure you have entered how many vehicles need to be transported',
                        });
                        return false;
                    }
                    return true;
            }
            return false;
        },
        submit () {
            axios.post(this.saveQuoteRoute, {
                quoteId: this.quoteId,
                vehicleTypeId: this.selectedVehicleType.vehicleTypeId,
                status: 'awaiting price',
                quotePrice: null,
                transportType: this.selectedTransportType,
                collectionDate: this.collectionDate,
                collectionTime: this.collectionTime,
                collectionLocationCoords: [this.$refs.collectionLatitudeInput.value, this.$refs.collectionLongitudeInput.value],
                collectionLocationAddress: this.selectedCollectionAddress,
                collectionLocale: this.selectedCollectionLocale,
                collectionCompanyName: this.collectionCompanyName,
                deliveryDate: this.deliveryDate,
                deliveryTime: this.deliveryTime,
                deliveryLocationCoords: [this.$refs.deliveryLatitudeInput.value, this.$refs.deliveryLongitudeInput.value],
                deliveryLocationAddress: this.selectedDeliveryAddress,
                deliveryLocale: this.selectedDeliveryLocale,
                deliveryCompanyName: this.deliveryCompanyName,
                customerContactName: this.customerContactName,
                jobNotes: this.jobNotes,
                vehicleCount: this.vehicleCount,
                quoteMileage: this.estimatedMileage
            }).then((response) => {
                window.onbeforeunload = null;
                Swal.fire({
                    icon: 'success',
                    title: 'Request sent',
                    text: 'Your quote will be looked at and responded to shortly.',
                    willClose: () => {
                        location.replace(response.data);
                    }
                });
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Could not add quote',
                    text: error,
                });
            });
        },
        fixDate (dateString) {
            const [day, month, year] = dateString.split('/');
            const stringDate = new Date(year, month - 1, day).toDateString(); //strips timezone
            return Date.parse(stringDate); //convert to unix timestamp for comparisons
        }
    }
}
</script>

<style scoped>
    @media (min-width: 992px) {
        .max-height-lg {
            max-height: 1000px;
        }
    }
</style>
